var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3331 11.6654H53.6665V20.9987H51.3331V23.332H37.3331C36.7143 23.332 36.1208 23.5779 35.6832 24.0154C35.2457 24.453 34.9998 25.0465 34.9998 25.6654V27.9987C34.9998 29.2364 34.5082 30.4234 33.633 31.2985C32.7578 32.1737 31.5708 32.6654 30.3331 32.6654H22.4465C21.5598 32.6654 20.7432 33.1787 20.3465 33.972L14.6298 45.382C14.2332 46.1754 13.4398 46.6654 12.5532 46.6654H4.66648C4.66648 46.6654 -2.33352 46.6654 6.99982 32.6654C6.99982 32.6654 13.9998 23.332 4.66648 23.332V11.6654H6.99982L8.16648 9.33203H15.1665L16.3331 11.6654ZM32.6665 27.9987V25.6654C32.6665 25.0465 32.4207 24.453 31.9831 24.0154C31.5455 23.5779 30.952 23.332 30.3331 23.332H27.9998C27.9998 23.332 25.6665 25.6654 27.9998 27.9987C26.7621 27.9987 25.5752 27.507 24.7 26.6319C23.8248 25.7567 23.3332 24.5697 23.3332 23.332C22.7143 23.332 22.1208 23.5779 21.6832 24.0154C21.2456 24.453 20.9998 25.0465 20.9998 25.6654V27.9987C20.9998 28.6175 21.2456 29.211 21.6832 29.6486C22.1208 30.0862 22.7143 30.332 23.3332 30.332H30.3331C30.952 30.332 31.5455 30.0862 31.9831 29.6486C32.4207 29.211 32.6665 28.6175 32.6665 27.9987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario);
export default __webpack_public_path__ + "static/media/scenario.887d3139be6073ccf63c123c4b9b8edb.svg";
export { ForwardRef as ReactComponent };